import { render, staticRenderFns } from "./ContentCreateTranslation.vue?vue&type=template&id=a06861a0&"
import script from "./ContentCreateTranslation.vue?vue&type=script&lang=js&"
export * from "./ContentCreateTranslation.vue?vue&type=script&lang=js&"
import style0 from "./ContentCreateTranslation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports